import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../../environments/environment';

export interface EquipoEmergenciaPesvItem {
  id: number;
  descripcion: string;
  estado: number;
  fechacreacion?: string;
  fechamodificacion?: string;
}

@Injectable({
  providedIn: 'root',
})
export class EquiposEmergenciaPesvService {
  private apiUrl = `${environment.apiUrl}/api/equipos_emergencia_pesv`;

  constructor(private http: HttpClient) {}

  getAll(): Observable<
    | EquipoEmergenciaPesvItem[]
    | { equipos_emergencia_pesv?: EquipoEmergenciaPesvItem[]; data?: EquipoEmergenciaPesvItem[] }
  > {
    return this.http.get<
      | EquipoEmergenciaPesvItem[]
      | { equipos_emergencia_pesv?: EquipoEmergenciaPesvItem[]; data?: EquipoEmergenciaPesvItem[] }
    >(this.apiUrl, {
      withCredentials: true,
    });
  }
}
